<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.19828 6.91379V2.75H11.8017V6.91379M4.92241 11.0776H11.0776M2.75 7.09483H13.25V11.8017C13.25 12.6016 12.6016 13.25 11.8017 13.25H4.19828C3.39841 13.25 2.75 12.6016 2.75 11.8017V7.09483Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
